import { Status } from '@40seas/entities/common';
import { EnumColor } from '@40seas/frontend/common/providers';

export const statusColorMapping = {
    [Status.Pending]: 'default',
    [Status.InProgress]: 'info',
    [Status.Done]: 'success',
    [Status.Failed]: 'error',
} as { [key in Status]: EnumColor };
